import { Fragment, h } from 'preact';

const Results = () => (
  <Fragment>
    <ul className="nav-bar scrolled shadow" id="navbar-register">
      <li className="sds-logo-container">
        <a href="/#intro" className="js-scroll-trigger">
          <div className="sds-logo-colored-container">
            <img
              src="../../assets/images/sds-logo-colored.svg"
              className="sds-logo-colored"
            />
            <hr className="sds-logo-colored-vertical-line" />
            <span className="sds-logo-colored-text">WoC</span>
          </div>
        </a>
      </li>

      <div className="nav-div">
        <li className="nav-items">
          <a href="/#about" className="nav-links js-scroll-trigger">
            About
          </a>
        </li>
        <li className="nav-items">
          <a href="/#process" className="nav-links js-scroll-trigger">
            Process
          </a>
        </li>
        <li className="nav-items">
          <a href="/#timeline" className="nav-links js-scroll-trigger">
            Timeline
          </a>
        </li>
        <li className="nav-items">
          <a href="/#guidelines" className="nav-links js-scroll-trigger">
            Guidelines
          </a>
        </li>
        <li className="nav-items">
          <a href="/results" className="nav-links">
            Results
          </a>
        </li>
        {/* <li className="nav-items">
          <a
            href="/checksubmission"
            className="nav-links"
            style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}
          >
            Check Submission
          </a>
        </li> */}
      </div>
    </ul>
    <div className="result-container">
      <div className="result-heading">Selected WoC students</div>
      <div className="result-content">
        <div className="result-subheading">Developers</div>
        <ul className="result-bullet-container">
          <li className="result-bullet">Akshit Mandial (ME)</li>
          <li className="result-bullet">Ayush Chandekar (P&I)</li>
          <li className="result-bullet">Bipasha Gayary (GT)</li>
          <li className="result-bullet">Karan Singh (CE)</li>
          <li className="result-bullet">Manav Punjabi (ECE)</li>
          <li className="result-bullet">Priyanshu Chahal (M&C)</li>
          <li className="result-bullet">Srija Bal (GPT)</li>
          <li className="result-bullet">Varun Mallya (ME)</li>
        </ul>
        <div className="result-subheading">Designers</div>
        <ul className="result-bullet-container">
          <li className="result-bullet">Manthan (GT)</li>
          <li className="result-bullet">Sonia (MT)</li>
          <li className="result-bullet">Harshit Kumar Singh (CHE 2Y)</li>
        </ul>
        <div className="result-paragraph">
          We had a tough time selecting the best proposals out of all the
          amazing 100+ entries. If your proposal wasn&apos;t able to make it in,
          don&apos;t fret. Your proposal could use some more research about the
          project. You can still develop your project as a submission for
          SDSLabs&apos; Makers. The selected students have been contacted via
          email by their mentors.
        </div>
      </div>
    </div>
  </Fragment>
);

export default Results;
